import {
  array,
  boolean,
  InferInput,
  InferOutput,
  object,
  optional,
  pipe,
  safeParse,
  string,
  transform,
  ValiError,
} from 'valibot';
import { AlbumItemSchema } from '../apiSchema.ts';

export const AlbumMediaPageRequestArgsSchema = object({
  id: string(),
  isLibrary: optional(boolean()),
});

export type AlbumMediaPageRequestArgs = InferOutput<
  typeof AlbumMediaPageRequestArgsSchema
>;

export const AlbumMediaPageAPISchema = pipe(
  object({
    data: object({
      data: array(AlbumItemSchema),
    }),
  }),
  transform(({ data }) => {
    const { data: [album] } = data;

    return {
      ...album,
    };
  }),
);

export type AlbumMediaPageResponse = InferOutput<
  typeof AlbumMediaPageAPISchema
>;

export const $getAlbumMedia = async (
  player: MusicKit.MusicKitInstance,
  params: AlbumMediaPageRequestArgs,
): Promise<AlbumMediaPageResponse> => {
  const p = safeParse(
    AlbumMediaPageRequestArgsSchema,
    params,
  );
  if (!p.success) {
    throw new ValiError(p.issues);
  }
  const { id, isLibrary } = p.output;
  const library = isLibrary ?? true;
  const endpoint = library
    ? `/v1/me/library/albums/${id}`
    : `/v1/catalog/${player.storefrontId}/albums/${id}`;

  const response = await player.api.music(
    endpoint,
  ) as unknown as InferInput<typeof AlbumMediaPageAPISchema>;

  const parsed = safeParse(
    AlbumMediaPageAPISchema,
    response,
  );
  if (!parsed.success) {
    throw new ValiError(parsed.issues);
  }
  return parsed.output;
};
